import { initContract } from "@ts-rest/core";
import { z } from "zod";
import { UserSignupPurpose } from "../types/user";
import { InviteCodeValidResponseDto } from "../dto/user/invite-code-valid-response.dto";

const c = initContract();

export const userRegisterContract = c.router(
    {
        validateInviteCode: {
            method: "POST",
            path: "/validate-invite-code",
            body: z
                .object({
                    inviteCode: z.string(),
                })
                .strict(),
            responses: {
                200: c.type<InviteCodeValidResponseDto>(),
            },
        },
        register: {
            method: "POST",
            path: "/register",
            body: z
                .object({
                    email: z.string().email(),
                    inviteCode: z.string().optional(),
                    signupPurpose: z.nativeEnum(UserSignupPurpose).optional(),
                })
                .strict(),
            responses: {
                204: c.noBody(),
            },
        },
    },
    {
        pathPrefix: "/user/onboarding",
    },
);
